export default __webpack_public_path__ + "locales/it/JavascriptSdk.json?hash=c1f584f896bdfa0bbf8497edb8d235c4";